type ToggleElementFromArray = {
  array: (string | boolean)[]
  value: string
}

/**
 * To Toggle Values from array
 *
 * Will create an empty array if the received array value is not arrayx
 */
export const toggleElementFromArray = ({
  array,
  value,
}: ToggleElementFromArray): (string | boolean)[] => {
  let newArray = Array.isArray(array) ? array : []
  newArray.includes(value)
    ? (newArray = newArray.filter((id) => id !== value))
    : newArray.push(value)
  return newArray
}

/**
 * To check if the string is present in array
 *
 * String should be provided comma seperated.
 *
 * Will Return true if string is present in array
 */
export const isStringInArray = (value: string, list: string[]) => {
  // Split the given string into elements using comma as a separator
  const elements = value.split(',').map((element) => element.trim())

  // Check if any of the elements is in the array
  for (const element of elements) {
    if (list.includes(element)) {
      return true
    }
  }

  // If none of the elements is found in the array
  return false
}
